export default __webpack_public_path__ + "static/media/hero.e3ef74be.png";